import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlueCube = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.20551 13.5L1.20586 4.5L9 9V18L1.20551 13.5Z",
			fill: "#64BDE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.20551 4.5L9 0L16.7941 4.5L9 9",
			fill: "#0C98D0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9L16.7945 4.5V13.5L9 18",
			fill: "#D2EFF9"
		})
	]
});
export default SvgBlueCube;
